<template>
  <div>
    <BaseImage title="Projects" />
    <ProjectsContent />
  </div>
</template>
<script>
import BaseImage from "@/components/BaseImage";
import ProjectsContent from "@/components/Projects/ProjectsContent";
export default {
  components: { ProjectsContent, BaseImage },
};
</script>
